import { createAction } from "@reduxjs/toolkit";
import _ from "lodash";
import axios from "axios";
import { takeEvery, takeLatest, call, put, select, delay } from "redux-saga/effects";
import buildUrl from "build-url-ts";

import {
  ADD_LEARNER_TO_COURSE_REQUEST,
  ADDING_LEARNER_TO_COURSE_SUCCEEDED,
  ADDING_LEARNER_TO_COURSE_FAILED,
  FETCH_LEARNERS_REQUEST,
  FETCHING_LEARNERS_SUCCEEDED,
  FETCHING_LEARNERS_FAILED,
  FETCH_COURSE_LEARNERS_REQUEST,
  FETCHING_COURSE_LEARNERS_SUCCEEDED,
  FETCHING_COURSE_LEARNERS_FAILED,
  INVALIDATE_LEARNERS_STATE,
  INVALIDATE_ADD_LEARNERS_STATE,
  FETCH_LEARNING_RECORD_COURSE_REQUEST,
  FETCHING_LEARNING_RECORD_COURSE_SUCCEEDED,
  FETCHING_LEARNING_RECORD_COURSE_FAILED,
  UPDATE_LESSON_PROGRESS_REQUEST,
  START_COURSE_REQUEST,
  STARTING_COURSE_SUCCEEDED,
  STARTING_COURSE_FAILED,
  INVALIDATE_START_COURSE,
  COMPLETE_COURSE_REQUEST,
  COMPLETING_COURSE_SUCCEEDED,
  COMPLETING_COURSE_FAILED,
  INVALIDATE_COMPLETE_COURSE,
  FETCHING_MY_COURSES_REQUEST,
  FETCHING_MY_COURSES_SUCCEEDED,
  FETCHING_MY_COURSES_FAILED,
  CREATE_COURSE_CONTENT_SESSION_REQUEST,
  CREATING_COURSE_CONTENT_SESSION_SUCCEEDED,
  CREATING_COURSE_CONTENT_SESSION_FAILED,
  INVALIDATE_COURSE_CONTENT_SESSION,
  RECORD_QUESTION_SESSION_REQUEST,
  RECORDING_QUESTION_SESSION_SUCCEEDED,
  RECORDING_QUESTION_SESSION_FAILED,
  RECORD_ANSWER_FOR_QUESTION_REQUEST,
  COMPLETE_COURSE_CONTENT_SESSION_REQUEST,
  COMPLETING_COURSE_CONTENT_SESSION_SUCCEEDED,
  COMPLETING_COURSE_CONTENT_SESSION_FAILED,
  FETCH_COURSE_CONTENT_SESSION_REQUEST,
  FETCHING_COURSE_CONTENT_SESSION_SUCCEEDED,
  FETCHING_COURSE_CONTENT_SESSION_FAILED,
  FETCH_ASSESSMENT_REPORT_REQUEST,
  FETCHING_ASSESSMENT_REPORT_SUCCEEDED,
  FETCHING_ASSESSMENT_REPORT_FAILED,
  UPDATE_COURSE_CONTENT_SESSION_REQUEST,
  UPDATING_COURSE_CONTENT_SESSION_FAILED,
  UPDATING_COURSE_CONTENT_SESSION_SUCCEEDED,
  UPDATE_COURSE_SESSION_REQUEST,
  UPDATING_COURSE_SESSION_SUCCEEDED,
  UPDATING_COURSE_SESSION_FAILED,
  CREATE_LESSON_ANALYTICS_EVENT,
  CREATING_LESSON_ANALYTICS_EVENT_SUCCEEDED,
  CREATING_LESSON_ANALYTICS_EVENT_FAILED,
  RECORD_LESSON_ANALYTICS_EVENT,
  RECORDING_LESSON_ANALYTICS_EVENT_SUCCEEDED,
  RECORDING_LESSON_ANALYTICS_EVENT_FAILED,
  FETCH_LEARNING_RECORD_SIMULATION_REQUEST,
  FETCHING_LEARNING_RECORD_SIMULATION_SUCCEEDED,
  FETCHING_LEARNING_RECORD_SIMULATION_FAILED,
  START_SIMULATION,
  STARTING_SIMULATION_SUCCEEDED,
  STARTING_SIMULATION_FAILED,
  INVALIDATE_START_SIMULATION,
  COMPLETE_SIMULATION,
  COMPLETING_SIMULATION_SUCCEEDED,
  COMPLETING_SIMULATION_FAILED,
  FETCH_SIMULATION_REPORT_REQUEST,
  FETCHING_SIMULATION_REPORT_SUCCEEDED,
  FETCHING_SIMULATION_REPORT_FAILED,
  RESTART_SIMULATION,
  RESTARTING_SIMULATION_SUCCEEDED,
  RESTARTING_SIMULATION_FAILED,
  INVALIDATE_RESTART_SIMULATION,
  ENROLL_COURSE_REQUEST,
  ENROLLING_COURSE_SUCCEEDED,
  ENROLLING_COURSE_FAILED,
  ENROLL_SIMULATION_REQUEST,
  ENROLLING_SIMULATION_SUCCEEDED,
  ENROLLING_SIMULATION_FAILED,
  FETCH_LESSON_FOR_LEARNING_RECORD_REQUEST,
  FETCHING_LESSON_FOR_LEARNING_RECORD_SUCCEEDED,
  FETCHING_LESSON_FOR_LEARNING_RECORD_FAILED,
  FETCH_LESSON_PREVIEW_FOR_LEARNING_RECORD_REQUEST,
  FETCHING_LESSON_PREVIEW_FOR_LEARNING_RECORD_SUCCEEDED,
  FETCHING_LESSON_PREVIEW_FOR_LEARNING_RECORD_FAILED,
  INVALIDATE_COMPLETE_SIMULATION,
  INVALIDATE_SIMULATION_REPORT,
  RETAKE_COURSE_REQUEST,
  RETAKING_COURSE_SUCCEEDED,
  RETAKING_COURSE_FAILED,
  INVALIDATE_RETAKE_COURSE,
  RETAKE_SIMULATION_REQUEST,
  RETAKING_SIMULATION_SUCCEEDED,
  RETAKING_SIMULATION_FAILED,
  INVALIDATE_RETAKE_SIMULATION,
  FETCH_LEARNING_RECORD_PODCAST_REQUEST,
  FETCHING_LEARNING_RECORD_PODCAST_SUCCEEDED,
  FETCHING_LEARNING_RECORD_PODCAST_FAILED,
  START_PODCAST_REQUEST,
  STARTING_PODCAST_SUCCEEDED,
  STARTING_PODCAST_FAILED,
  INVALIDATE_START_PODCAST,
  UPDATE_PODCAST_SESSION_REQUEST,
  UPDATING_PODCAST_SESSION_SUCCEEDED,
  UPDATING_PODCAST_SESSION_FAILED,
  FETCH_TRANSCRIPTS_FOR_LEARNING_PODCAST_REQUEST,
  FETCHING_TRANSCRIPTS_FOR_LEARNING_PODCAST_SUCCEEDED,
  FETCHING_TRANSCRIPTS_FOR_LEARNING_PODCAST_FAILED,
  ENROLL_PODCAST_REQUEST,
  ENROLLING_PODCAST_SUCCEEDED,
  ENROLLING_PODCAST_FAILED,
  FETCH_TRANSCRIPTS_FOR_LEARNING_SIMULATION_REQUEST,
  FETCHING_TRANSCRIPTS_FOR_LEARNING_SIMULATION_SUCCEEDED,
  FETCHING_TRANSCRIPTS_FOR_LEARNING_SIMULATION_FAILED,
  JOIN_DAILY_ROOM_REQUEST,
  JOINING_DAILY_ROOM_SUCCEEDED,
  JOINING_DAILY_ROOM_FAILED,
  RESTART_SIMULATION_LESSON_SESSION_REQUEST,
  RESTARTING_SIMULATION_LESSON_SESSION_SUCCEEDED,
  RESTARTING_SIMULATION_LESSON_SESSION_FAILED,
  TRIGGER_SIMULATION_CALL_MESSAGE,
  TRIGGER_SIMULATION_CALL_MESSAGE_SUCCEEDED,
  TRIGGER_SIMULATION_CALL_MESSAGE_FAILED,
} from "../actionTypes";
import {
  AddLearnerToCourseRequest,
  AddLearnerToCourseResponse,
  FetchCourseLearnersErrorResponse,
  FetchCourseLearnersRequest,
  FetchCourseLearnersResponse,
  FetchLearnersRequest,
  FetchLearnersErrorResponse,
  FetchLearnersResponse,
  StartCourseResponse,
  StartCourseErrorResponse,
  CompleteCourseResponse,
  CompleteCourseErrorResponse,
  FetchMyCoursesRequest,
  FetchMyCoursesResponse,
  FetchMyCoursesErrorResponse,
  CreateCourseContentSessionRequest,
  CreateCourseContentSessionResponse,
  CreateCourseContentSessionErrorResponse,
  InvalidateCourseContentSession,
  RecordQuestionSessionRequest,
  RecordAnswerForQuestionRequest,
  RecordQuestionSessionErrorResponse,
  RecordQuestionSessionResponse,
  CompleteCourseContentSessionErrorResponse,
  CompleteCourseContentSessionResponse,
  CompleteCourseContentSessionRequest,
  FetchCourseContentSessionResponse,
  FetchCourseContentSessionErrorResponse,
  FetchCourseContentSessionRequest,
  FetchAssessmentReportResponse,
  FetchAssessmentReportErrorResponse,
  FetchAssessmentReportRequest,
  UpdateCourseContentSessionResponse,
  UpdateCourseContentSessionErrorResponse,
  UpdateCourseContentSessionRequest,
  UpdateCourseSessionRequest,
  UpdateCourseSessionResponse,
  UpdateCourseSessionErrorResponse,
  CompleteCourseRequest,
  RecordLessonAnalyticsResponse,
  RecordLessonAnalyticsErrorResponse,
  CreateLessonAnalyticsRequest,
  CreateLessonAnalyticsResponse,
  CreateLessonAnalyticsErrorResponse,
  RecordLessonAnalyticsEvent,
  FetchLearningRecordSimulationResponse,
  FetchLearningRecordSimulationErrorResponse,
  FetchLearningRecordCourseResponse,
  FetchLearningRecordCourseErrorResponse,
  StartSimulationErrorResponse,
  StartSimulationResponse,
  CompleteSimulationRequest,
  CompleteSimulationResponse,
  CompleteSimulationErrorResponse,
  FetchSimulationAssessmentReportRequest,
  FetchSimulationAssessmentReportResponse,
  FetchSimulationAssessmentReportErrorResponse,
  EnrollCourseResponse,
  EnrollCourseErrorResponse,
  FetchLessonForLearningRecordRequest,
  FetchLessonForLearningRecordResponse,
  FetchLessonForLearningRecordErrorResponse,
  FetchLessonPreviewForLearningRecordRequest,
  FetchLessonPreviewForLearningRecordResponse,
  FetchLessonPreviewForLearningRecordErrorResponse,
  RetakeCourseResponse,
  RetakeCourseErrorResponse,
  FetchLearningRecordPodcastResponse,
  FetchLearningRecordPodcastErrorResponse,
  StartPodcastResponse,
  StartPodcastErrorResponse,
  UpdatePodcastSessionRequest,
  UpdatePodcastSessionResponse,
  UpdatePodcastSessionErrorResponse,
  GetSimulationTranscriptsResponse,
  GetSimulationTranscriptsErrorResponse,
  EnrollCourseRequest,
  JoinDailyRoomResponse,
  JoinDailyRoomErrorResponse,
  RestartSimulationLessonSessionRequest,
  RestartSimulationLessonSessionResponse,
  RestartSimulationLessonSessionErrorResponse,
} from "src/types/coaching/learners";
import { GetPodcastTranscriptsErrorResponse, GetPodcastTranscriptsResponse } from "src/types/coaching/podcast";

// eslint-disable-next-line no-undef
const apiUrl = `${process.env.REACT_APP_COACHING_API_URL}`;

export const addLearnerToCourse = createAction<AddLearnerToCourseRequest>(
  ADD_LEARNER_TO_COURSE_REQUEST,
);
const addingLearnerToCourseSucceeded = createAction<AddLearnerToCourseResponse>(
  ADDING_LEARNER_TO_COURSE_SUCCEEDED,
);
const addingLearnerToCourseFailed = createAction<any>(
  ADDING_LEARNER_TO_COURSE_FAILED,
);

const addLearnerToCourseSaga = function* (
  action: ReturnType<typeof addLearnerToCourse>,
): any {
  const { id, allUsers, learners, dueDate } = action.payload;

  const url = buildUrl(apiUrl, {
    path: `api/1.0/courses/${id}/learners`,
  });

  const addLearnerToCourseApi = () => {
    return axios({
      method: "POST",
      url: url,
      data: {
        allUsers: allUsers,
        learners: learners,
        dueDate: dueDate
      },
    }).then((response) => response.data);
  };

  try {
    const response = yield call(addLearnerToCourseApi);
    yield put(addingLearnerToCourseSucceeded({ response: response }));
  } catch (error) {
    yield put(addingLearnerToCourseFailed({ error: error }));
  }
};

export const fetchCourseLearners = createAction<FetchCourseLearnersRequest>(
  FETCH_COURSE_LEARNERS_REQUEST,
);
const fetchingCourseLearnersSucceeded =
  createAction<FetchCourseLearnersResponse>(FETCHING_COURSE_LEARNERS_SUCCEEDED);
const fetchingCourseLearnersFailed =
  createAction<FetchCourseLearnersErrorResponse>(
    FETCHING_COURSE_LEARNERS_FAILED,
  );

const fetchCourseLearnersSaga = function* (
  action: ReturnType<typeof fetchCourseLearners>,
): any {
  const { course, status, page, limit, query, userGroups } = action.payload;

  const url = buildUrl(apiUrl, {
    path: `api/1.0/courses/${course}/learners`,
  });

  const params = new URLSearchParams();
  params.append("status", status ?? "ALL");
  params.append("page", String(page));
  params.append("limit", String(limit));
  if (query) params.append("query", query);
  if (userGroups?.length) {
    userGroups.forEach((id) => params.append("userGroups", id));
  }

  const fetchCourseLearnersAPI = () => {
    return axios({
      method: "GET",
      url: url,
      params,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchCourseLearnersAPI);
    yield put(fetchingCourseLearnersSucceeded({ response: response }));
  } catch (error) {
    yield put(fetchingCourseLearnersFailed({ error: error }));
  }
};

export const fetchLearners = createAction<FetchLearnersRequest>(FETCH_LEARNERS_REQUEST);
const fetchingLearnersSucceeded = createAction<FetchLearnersResponse>(FETCHING_LEARNERS_SUCCEEDED);
const fetchingLearnersFailed = createAction<FetchLearnersErrorResponse>(FETCHING_LEARNERS_FAILED);

const fetchLearnersSaga = function* (
  action: ReturnType<typeof fetchLearners>,
): any {
  const { page, query } = action.payload;

  const url = buildUrl(apiUrl, {
    path: "api/1.0/learners",
  });

  const fetchLearnersAPI = () => {
    return axios({
      method: "GET",
      url: url,
      params: {
        page: page,
        query: query,
      },
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchLearnersAPI);
    yield put(fetchingLearnersSucceeded({ response: response }));
  } catch (error) {
    yield put(fetchingLearnersFailed({ error: error }));
  }
};

export const fetchMyCourses = createAction<FetchMyCoursesRequest>(FETCHING_MY_COURSES_REQUEST);
const fetchingMyCoursesSucceeded = createAction<FetchMyCoursesResponse>(FETCHING_MY_COURSES_SUCCEEDED);
const fetchingMyCoursesFailed = createAction<FetchMyCoursesErrorResponse>(FETCHING_MY_COURSES_FAILED);

const fetchMyCoursesSaga = function* (action: ReturnType<typeof fetchMyCourses>): any {
  const request = action.payload;
  const params: Record<string, string | number> = {
    status: request.status,
    page: request.page,
    limit: request.limit,
  };
  if (request.query != null) {
    params.query = request.query;
  }

  const fetchMyCoursesApi = () => {
    return axios({
      method: "GET",
      url: `${apiUrl}/api/1.0/courses`,
      params,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchMyCoursesApi);
    yield put(
      fetchingMyCoursesSucceeded({
        status: action.payload.status,
        response: response,
      }),
    );
  } catch (error) {
    yield put(fetchingMyCoursesFailed({ status: request.status, error: error }));
  }
};

export const startCourse = createAction<string>(START_COURSE_REQUEST);
const startingCourseSucceeded = createAction<StartCourseResponse>(STARTING_COURSE_SUCCEEDED);
const startingCourseFailed = createAction<StartCourseErrorResponse>(STARTING_COURSE_FAILED);

const startCourseSaga = function* (action: ReturnType<typeof startCourse>): any {
  const course = action.payload;

  const url = buildUrl(apiUrl, {
    path: `api/1.0/courses/${course}/start`,
  });

  const startCourseAPI = () => {
    return axios({
      method: "POST",
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(startCourseAPI);
    yield put(startingCourseSucceeded(response));
  } catch (error) {
    yield put(startingCourseFailed({ id: course, error }));
  }
};

export const enrollCourse = createAction<EnrollCourseRequest>(ENROLL_COURSE_REQUEST);
const enrollingCourseSucceeded = createAction<EnrollCourseResponse>(ENROLLING_COURSE_SUCCEEDED);
const enrollingCourseFailed = createAction<EnrollCourseErrorResponse>(ENROLLING_COURSE_FAILED);

const enrollCourseSaga = function* (action: ReturnType<typeof enrollCourse>): any {
  const { course, parentCourse, type } = action.payload;

  const url = buildUrl(apiUrl, {
    path: `api/1.0/courses/${course}/enroll`,
  });

  let data = {}

  if(type === "microlearning") {
    data = {
      parentCourse: parentCourse,
      type: "microlearning"
    }
  }

  const enrollCourseAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: data
    }).then((response) => response.data);
  };

  try {
    const response = yield call(enrollCourseAPI);
    yield put(enrollingCourseSucceeded({ id: course, response: response }));
  } catch (error) {
    yield put(enrollingCourseFailed({ id: course, error }));
  }
};

export const enrollSimulation = createAction<EnrollCourseRequest>(ENROLL_SIMULATION_REQUEST);
const enrollingSimulationSucceeded = createAction<EnrollCourseResponse>(ENROLLING_SIMULATION_SUCCEEDED);
const enrollingSimulationFailed = createAction<EnrollCourseErrorResponse>(ENROLLING_SIMULATION_FAILED);

const enrollSimulationSaga = function* (action: ReturnType<typeof enrollSimulation>): any {
  const { course, parentCourse } = action.payload;

  const url = buildUrl(apiUrl, {
    path: `api/1.0/courses/${course}/enroll`,
  });

  const enrollSimulationAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: {
        parentCourse: parentCourse,
        type: "simulation"
      }
    }).then((response) => response.data);
  };

  try {
    const response = yield call(enrollSimulationAPI);
    yield put(enrollingSimulationSucceeded({ id: course, response: response }));
  } catch (error) {
    yield put(enrollingSimulationFailed({ id: course, error }));
  }
};

//Enroll Podcast
export const enrollPodcast = createAction<EnrollCourseRequest>(ENROLL_PODCAST_REQUEST);
const enrollingPodcastSucceeded = createAction<EnrollCourseResponse>(ENROLLING_PODCAST_SUCCEEDED);
const enrollingPodcastFailed = createAction<EnrollCourseErrorResponse>(ENROLLING_PODCAST_FAILED);

const enrollPodcastSaga = function* (action: ReturnType<typeof enrollPodcast>): any {
  const { course, parentCourse, type } = action.payload;

  const url = buildUrl(apiUrl, {
    path: `api/1.0/courses/${course}/enroll`,
  });

  const enrollPodcastAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: {
        parentCourse: parentCourse,
        type: type
      }
    }).then((response) => response.data);
  };

  try {
    const response = yield call(enrollPodcastAPI);
    yield put(enrollingPodcastSucceeded({ id: course, response: response }));
  } catch (error) {
    yield put(enrollingPodcastFailed({ id: course, error }));
  }
};

export const retakeCourse = createAction<string>(RETAKE_COURSE_REQUEST);
const retakingCourseSucceeded = createAction<RetakeCourseResponse>(RETAKING_COURSE_SUCCEEDED);
const retakingCourseFailed = createAction<RetakeCourseErrorResponse>(RETAKING_COURSE_FAILED);

const retakeCourseSaga = function* (action: ReturnType<typeof retakeCourse>): any {
  const course = action.payload;

  const url = buildUrl(apiUrl, {
    path: `api/1.0/courses/${course}/retake`,
  });

  const retakeCourseAPI = () => {
    return axios({
      method: "POST",
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(retakeCourseAPI);
    yield put(retakingCourseSucceeded({ course: course, ...response }));
  } catch (error) {
    yield put(retakingCourseFailed({ id: course, error }));
  }
};

export const invalidateRetakeCourse = createAction<string>(INVALIDATE_RETAKE_COURSE);

export const updateCourseSession = createAction<UpdateCourseSessionRequest>(UPDATE_COURSE_SESSION_REQUEST);
const updatingCourseSessionSucceeded = createAction<UpdateCourseSessionResponse>(UPDATING_COURSE_SESSION_SUCCEEDED);
const updatingCourseSessionFailed = createAction<UpdateCourseSessionErrorResponse>(UPDATING_COURSE_SESSION_FAILED);

const updateCourseSessionSaga = function* (action: ReturnType<typeof updateCourseSession>): any {
  const request = action.payload as UpdateCourseSessionRequest;

  const url = buildUrl(apiUrl, {
    path: `api/1.0/courses/${request.id}/sessions`,
  });

  const updateCourseAPI = () => {
    return axios({
      method: "PUT",
      url: url,
      data: {
        duration: request.duration,
      }
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updateCourseAPI);
    yield put(updatingCourseSessionSucceeded(response));
  } catch (error) {
    yield put(updatingCourseSessionFailed({ id: request.id, error }));
  }
};

export const invalidateStartCourse = createAction<string>(INVALIDATE_START_COURSE);

//Complete Course
export const completeCourse = createAction<CompleteCourseRequest>(COMPLETE_COURSE_REQUEST);
const completingCourseSucceeded = createAction<CompleteCourseResponse>(COMPLETING_COURSE_SUCCEEDED);
const completingCourseFailed = createAction<CompleteCourseErrorResponse>(COMPLETING_COURSE_FAILED);

const completeCourseSaga = function* (action: ReturnType<typeof completeCourse>): any {
  const { id, duration } = action.payload as CompleteCourseRequest;

  const url = buildUrl(apiUrl, {
    path: `api/1.0/courses/${id}/complete`,
  });

  const completeCourseAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: {
        duration: duration,
      }
    }).then((response) => response.data);
  };

  try {
    const response = yield call(completeCourseAPI);
    yield put(completingCourseSucceeded(response));
  } catch (error) {
    yield put(completingCourseFailed({ id: id, error }));
  }
};

export const invalidateCompleteCourse = createAction<string>(INVALIDATE_COMPLETE_COURSE);

export const invalidateAddLearnersState = createAction<void>(
  INVALIDATE_ADD_LEARNERS_STATE,
);
export const invalidateLearnersState = createAction<void>(
  INVALIDATE_LEARNERS_STATE,
);

// fetch course
export const fetchLearningRecordCourse = createAction<string>(FETCH_LEARNING_RECORD_COURSE_REQUEST);
const fetchingLearningRecordCourseSucceeded = createAction<FetchLearningRecordCourseResponse>(FETCHING_LEARNING_RECORD_COURSE_SUCCEEDED);
const fetchingLearningRecordCourseFailed = createAction<FetchLearningRecordCourseErrorResponse>(FETCHING_LEARNING_RECORD_COURSE_FAILED);

const fetchLearningRecordCourseSaga = function* (action: ReturnType<typeof fetchLearningRecordCourse>): any {
  const id = action.payload;

  const url = buildUrl(apiUrl, {
    path: `api/1.0/courses/${id}`,
  });

  const fetchLearningRecordCourseApi = () => {
    return axios({
      method: "GET",
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchLearningRecordCourseApi);
    yield put(
      fetchingLearningRecordCourseSucceeded({
        response: response,
      }),
    );
  } catch (error) {
    console.log(error);
    yield put(fetchingLearningRecordCourseFailed({ id: id, error: error }));
  }
};

// Restart Lesson simulation
export const restartSimulationLessonSession = createAction<RestartSimulationLessonSessionRequest>(RESTART_SIMULATION_LESSON_SESSION_REQUEST);
const restartingSimulationLessonSessionSucceeded = createAction<RestartSimulationLessonSessionResponse>(RESTARTING_SIMULATION_LESSON_SESSION_SUCCEEDED);
const restartingSimulationLessonSessionFailed = createAction<RestartSimulationLessonSessionErrorResponse>(RESTARTING_SIMULATION_LESSON_SESSION_FAILED);

const restartSimulationLessonSessionSaga = function* (action: ReturnType<typeof restartSimulationLessonSession>): any {
  const request = action.payload as RestartSimulationLessonSessionRequest;

  const url = buildUrl(apiUrl, {
    path: `api/1.0/course_content/sessions/${request.session}/restart`,
  });

  const restartSimulationLessonSessionAPI = () => {
    return axios({
      method: "POST",
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(restartSimulationLessonSessionAPI);
    yield put(restartingSimulationLessonSessionSucceeded({
      course: request.course,
      learningRecord: request.learningRecord,
      response: response,
    }));
  } catch (error) {
    yield put(restartingSimulationLessonSessionFailed({
      course: request.course,
      learningRecord: request.learningRecord,
      type: request.type,
      session: request.session,
      error: error
    }));
  }
};

// Analytics events
export const createLessonAnalyticsEvent = createAction<CreateLessonAnalyticsRequest>(CREATE_LESSON_ANALYTICS_EVENT);
const creatingLessonAnalyticsEventSucceeded = createAction<CreateLessonAnalyticsResponse>(CREATING_LESSON_ANALYTICS_EVENT_SUCCEEDED);
const creatingLessonAnalyticsEventFailed = createAction<CreateLessonAnalyticsErrorResponse>(CREATING_LESSON_ANALYTICS_EVENT_FAILED);

const createLessonAnalyticsEventSaga = function* (
  action: ReturnType<typeof createLessonAnalyticsEvent>,
): any {
  const event = action.payload as CreateLessonAnalyticsRequest;

  const recordCourseSessionAnalyticsAPI = () => {
    return axios({
      method: "POST",
      url: `${apiUrl}/api/1.0/learning_record/lessons/analytics`,
      data: event,
    }).then((response) => response.data);
  };

  try {
    const { creating, session } = yield select((state: any) => {
      const sessions = _.get(state.learners, `course[${event.learningRecord}].item.sessions`);
      const session = sessions.find((item) => item.id === event.lesson && item.type === 'lesson');

      return {
        creating: session?.creating,
        session: session?.analyticsSession,
      };
    });

    console.log("Creating lesson analytics event", creating, session);

    if (creating || session) {
      console.log("Session already exists or is being created");
      return;
    }

    const response = yield call(recordCourseSessionAnalyticsAPI);
    yield put(creatingLessonAnalyticsEventSucceeded({
      course: event.course,
      lesson: event.lesson,
      learningRecord: event.learningRecord,
      response: response,
    }));
  } catch (error) {
    yield put(creatingLessonAnalyticsEventFailed({
      course: event.course,
      lesson: event.lesson,
      learningRecord: event.learningRecord,
      error: error
    }));
  }
};

export const recordLessonAnalyticsEvent = createAction<RecordLessonAnalyticsEvent>(RECORD_LESSON_ANALYTICS_EVENT);
const recordingLessonAnalyticsEventSucceeded = createAction<RecordLessonAnalyticsResponse>(RECORDING_LESSON_ANALYTICS_EVENT_SUCCEEDED);
const recordingLessonAnalyticsEventFailed = createAction<RecordLessonAnalyticsErrorResponse>(RECORDING_LESSON_ANALYTICS_EVENT_FAILED);

const recordLessonAnalyticsEventSaga = function* (
  action: ReturnType<typeof recordLessonAnalyticsEvent>,
): any {
  const event = action.payload;

  const recordCourseSessionAnalyticsAPI = () => {
    return axios({
      method: "POST",
      url: `${apiUrl}/api/1.0/learning_record/lessons/analytics`,
      data: event,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(recordCourseSessionAnalyticsAPI);
    yield put(recordingLessonAnalyticsEventSucceeded({
      course: event.course,
      lesson: event.lesson,
      learningRecord: event.learningRecord,
      session: event.session,
      response: response,
    }));
  } catch (error) {
    yield put(recordingLessonAnalyticsEventFailed({
      course: event.course,
      lesson: event.lesson,
      learningRecord: event.learningRecord,
      session: event.session,
      error: error
    }));
  }
};

export const createCourseContentSession = createAction<CreateCourseContentSessionRequest>(CREATE_COURSE_CONTENT_SESSION_REQUEST);
const creatingCourseContentSessionSucceeded = createAction<CreateCourseContentSessionResponse>(CREATING_COURSE_CONTENT_SESSION_SUCCEEDED);
const creatingCourseContentSessionFailed = createAction<CreateCourseContentSessionErrorResponse>(CREATING_COURSE_CONTENT_SESSION_FAILED);

const createCourseContentSessionSaga = function* (action: ReturnType<typeof createCourseContentSession>): any {
  const event = action.payload as CreateCourseContentSessionRequest;

  const recordSessionAPI = () => {
    return axios({
      method: "POST",
      url: `${apiUrl}/api/1.0/course_content/sessions`,
      data: event,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(recordSessionAPI);
    yield put(creatingCourseContentSessionSucceeded({
      course: event.course,
      learningRecord: event.learningRecord,
      response: response,
    }));
  } catch (error) {
    yield put(creatingCourseContentSessionFailed({
      course: event.course,
      learningRecord: event.learningRecord,
      id: event.id,
      type: event.type,
      error: error
    }));
  }
};

//Update course content session
export const updateCourseContentSession = createAction<UpdateCourseContentSessionRequest>(UPDATE_COURSE_CONTENT_SESSION_REQUEST);
const updatingCourseContentSessionSucceeded = createAction<UpdateCourseContentSessionResponse>(UPDATING_COURSE_CONTENT_SESSION_SUCCEEDED);
const updatingCourseContentSessionFailed = createAction<UpdateCourseContentSessionErrorResponse>(UPDATING_COURSE_CONTENT_SESSION_FAILED);

const updateCourseContentSessionSaga = function* (action: ReturnType<typeof updateCourseContentSession>): any {
  const event = action.payload as UpdateCourseContentSessionRequest;

  const recordSessionAPI = () => {
    return axios({
      method: "PUT",
      url: `${apiUrl}/api/1.0/course_content/sessions/${event.session}`,
      data: event,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(recordSessionAPI);
    yield put(updatingCourseContentSessionSucceeded({
      course: event.course,
      learningRecord: event.learningRecord,
      response: response,
    }));
  } catch (error) {
    yield put(updatingCourseContentSessionFailed({
      course: event.course,
      learningRecord: event.learningRecord,
      id: event.id,
      type: event.type,
      error: error
    }));
  }
};

export const fetchCourseContentSession = createAction<FetchCourseContentSessionRequest>(FETCH_COURSE_CONTENT_SESSION_REQUEST);
const fetchingCourseContentSessionSucceeded = createAction<FetchCourseContentSessionResponse>(FETCHING_COURSE_CONTENT_SESSION_SUCCEEDED);
const fetchingCourseContentSessionFailed = createAction<FetchCourseContentSessionErrorResponse>(FETCHING_COURSE_CONTENT_SESSION_FAILED);

const fetchCourseContentSessionSaga = function* (action: ReturnType<typeof fetchCourseContentSession>): any {
  const event = action.payload as FetchCourseContentSessionRequest;

  const recordSessionAPI = () => {
    return axios({
      method: "GET",
      url: `${apiUrl}/api/1.0/course_content/sessions/${event.session}`,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(recordSessionAPI);
    yield put(fetchingCourseContentSessionSucceeded({
      course: event.course,
      learningRecord: event.learningRecord,
      response: response,
    }));
  } catch (error) {
    yield put(fetchingCourseContentSessionFailed({
      course: event.course,
      learningRecord: event.learningRecord,
      id: event.id,
      type: event.type,
      error: error
    }));
  }
};

//Assessment Report
export const fetchAssessmentReport = createAction<FetchAssessmentReportRequest>(FETCH_ASSESSMENT_REPORT_REQUEST);
const fetchingAssessmentReportSucceeded = createAction<FetchAssessmentReportResponse>(FETCHING_ASSESSMENT_REPORT_SUCCEEDED);
const fetchingAssessmentReportFailed = createAction<FetchAssessmentReportErrorResponse>(FETCHING_ASSESSMENT_REPORT_FAILED);

const fetchAssessmentReportSaga = function* (action: ReturnType<typeof fetchAssessmentReport>): any {
  const event = action.payload as FetchAssessmentReportRequest;

  const recordReportAPI = () => {
    return axios({
      method: "GET",
      url: `${apiUrl}/api/1.0/course_content/sessions/${event.session}/report`,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(recordReportAPI);
    yield put(fetchingAssessmentReportSucceeded({
      course: event.course,
      learningRecord: event.learningRecord,
      response: response,
    }));
  } catch (error) {
    yield put(fetchingAssessmentReportFailed({
      course: event.course,
      learningRecord: event.learningRecord,
      id: event.id,
      type: event.type,
      error: error
    }));
  }
};

export const invalidateCourseContentSession = createAction<InvalidateCourseContentSession>(INVALIDATE_COURSE_CONTENT_SESSION);

export const completeCourseContentSession = createAction<CompleteCourseContentSessionRequest>(COMPLETE_COURSE_CONTENT_SESSION_REQUEST);
const completingCourseContentSessionSucceeded = createAction<CompleteCourseContentSessionResponse>(COMPLETING_COURSE_CONTENT_SESSION_SUCCEEDED);
const completingCourseContentSessionFailed = createAction<CompleteCourseContentSessionErrorResponse>(COMPLETING_COURSE_CONTENT_SESSION_FAILED);

const completeCourseContentSessionSaga = function* (action: ReturnType<typeof completeCourseContentSession>): any {
  const event = action.payload as CompleteCourseContentSessionRequest;

  const recordSessionAPI = () => {
    return axios({
      method: "POST",
      url: `${apiUrl}/api/1.0/course_content/sessions/${event.session}/complete`,
      data: event,
    }).then((response) => response.data);
  };



  try {
    if (event.type === 'assessment') {
      let questionsSynced = false;

      do {
        const questions = yield select((state: any) => {
          const sessions = _.get(state.learners, `course[${event.learningRecord}].item.sessions`);
          const session = sessions.find((item) => item.id === event.id && item.type === event.type);
          console.log("Session", session);
          return (session?.questions || []).map((question) => {
            return question.created;
          });
        });
        console.log("Questions", questions);

        questionsSynced = questions.every((question) => question);
        if (!questionsSynced) {
          yield delay(2000);
          console.log("Waiting for questions to sync");
        }

      } while (!questionsSynced);
    }

    const response = yield call(recordSessionAPI);
    yield put(completingCourseContentSessionSucceeded({
      course: event.course,
      learningRecord: event.learningRecord,
      response: response,
    }));
  } catch (error) {
    yield put(completingCourseContentSessionFailed({
      course: event.course,
      learningRecord: event.learningRecord,
      id: event.id,
      type: event.type,
      error: error
    }));
  }
};

//Question analytics
export const recordAnswerForQuestion = createAction<RecordAnswerForQuestionRequest>(RECORD_ANSWER_FOR_QUESTION_REQUEST);

export const recordQuestionSession = createAction<RecordQuestionSessionRequest>(RECORD_QUESTION_SESSION_REQUEST);
const recordingQuestionSessionSucceeded = createAction<RecordQuestionSessionResponse>(RECORDING_QUESTION_SESSION_SUCCEEDED);
const recordingQuestionSessionFailed = createAction<RecordQuestionSessionErrorResponse>(RECORDING_QUESTION_SESSION_FAILED);

const recordQuestionSessionSaga = function* (
  action: ReturnType<typeof recordQuestionSession>,
): any {
  const recordAssessmentQuestionAnalyticsAPI = () => {
    const { session } = action.payload as RecordQuestionSessionRequest;

    return axios({
      method: "POST",
      url: `${apiUrl}/api/1.0/course_content/sessions/${session}/question`,
      data: action.payload,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(recordAssessmentQuestionAnalyticsAPI);
    yield put(recordingQuestionSessionSucceeded({
      course: action.payload.course,
      learningRecord: action.payload.learningRecord,
      assessment: action.payload.assessment,
      question: action.payload.question,
      session: action.payload.session,
      response: response,
    }));
  } catch (error) {
    yield put(recordingQuestionSessionFailed({
      course: action.payload.course,
      learningRecord: action.payload.learningRecord,
      assessment: action.payload.assessment,
      question: action.payload.question,
      session: action.payload.session,
      error: error
    }));
  }
};

export const updateLessonProgress = createAction<any>(UPDATE_LESSON_PROGRESS_REQUEST);


//Simulation
export const fetchLearningRecordSimulation = createAction<string>(FETCH_LEARNING_RECORD_SIMULATION_REQUEST);
const fetchingLearningRecordSimulationSucceeded = createAction<FetchLearningRecordSimulationResponse>(FETCHING_LEARNING_RECORD_SIMULATION_SUCCEEDED);
const fetchingLearningRecordSimulationFailed = createAction<FetchLearningRecordSimulationErrorResponse>(FETCHING_LEARNING_RECORD_SIMULATION_FAILED);

const fetchLearningRecordSimulationSaga = function* (action: ReturnType<typeof fetchLearningRecordSimulation>): any {
  const id = action.payload;

  const url = buildUrl(apiUrl, {
    path: `api/1.0/simulations/${id}`,
  });

  const fetchLearningRecordSimulationApi = () => {
    return axios({
      method: "GET",
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchLearningRecordSimulationApi);
    yield put(
      fetchingLearningRecordSimulationSucceeded({
        response: response,
      }),
    );
  } catch (error) {
    console.log(error);
    yield put(fetchingLearningRecordSimulationFailed({ id: id, error: error }));
  }
};

//Start Simulation
export const startSimulation = createAction<string>(START_SIMULATION);
const startingSimulationSucceeded = createAction<StartSimulationResponse>(STARTING_SIMULATION_SUCCEEDED);
const startingSimulationFailed = createAction<StartSimulationErrorResponse>(STARTING_SIMULATION_FAILED);

const startSimulationSaga = function* (action: ReturnType<typeof startSimulation>): any {
  const course = action.payload;

  const url = buildUrl(apiUrl, {
    path: `api/1.0/simulations/${course}/start`,
  });

  const startCourseAPI = () => {
    return axios({
      method: "POST",
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(startCourseAPI);
    yield put(startingSimulationSucceeded(response));
  } catch (error) {
    yield put(startingSimulationFailed({ id: course, error }));
  }
};

export const invalidateStartSimulation = createAction<string>(INVALIDATE_START_SIMULATION);

//Creating room for dailyco and getting meeting token 

export const joinDailyRoom = createAction<string>(JOIN_DAILY_ROOM_REQUEST);
const joiningDailyRoomSucceeded = createAction<JoinDailyRoomResponse>(JOINING_DAILY_ROOM_SUCCEEDED);
const joiningDailyRoomFailed = createAction<JoinDailyRoomErrorResponse>(JOINING_DAILY_ROOM_FAILED);

const joinDailyRoomSaga = function* (action: ReturnType<typeof joinDailyRoom>): any {
  const session = action.payload;

  const url = buildUrl(apiUrl, {
    path: `api/1.0/simulations/daily/call/room`,
    queryParams: { session },
  });

  const joinRoomAPI = () => {
    return axios({
      method: "POST",
      url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(joinRoomAPI);
    yield put(joiningDailyRoomSucceeded({ session, ...response }));
  } catch (error) {
    yield put(joiningDailyRoomFailed({ session, error }));
  }
};


//Restart Simulation
export const restartSimulation = createAction<string>(RESTART_SIMULATION);
const restartingSimulationSucceeded = createAction<StartSimulationResponse>(RESTARTING_SIMULATION_SUCCEEDED);
const restartingSimulationFailed = createAction<StartSimulationErrorResponse>(RESTARTING_SIMULATION_FAILED);

const restartSimulationSaga = function* (action: ReturnType<typeof startSimulation>): any {
  const course = action.payload;

  const url = buildUrl(apiUrl, {
    path: `api/1.0/simulations/${course}/restart`,
  });

  const restartCourseAPI = () => {
    return axios({
      method: "POST",
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(restartCourseAPI);
    yield put(restartingSimulationSucceeded(response));
  } catch (error) {
    yield put(restartingSimulationFailed({ id: course, error }));
  }
};

export const invalidateRestartSimulation = createAction<string>(INVALIDATE_RESTART_SIMULATION);

export const retakeSimulation = createAction<string>(RETAKE_SIMULATION_REQUEST);
const retakingSimulationSucceeded = createAction<RetakeCourseResponse>(RETAKING_SIMULATION_SUCCEEDED);
const retakingSimulationFailed = createAction<RetakeCourseErrorResponse>(RETAKING_SIMULATION_FAILED);

const retakeSimulationSaga = function* (action: ReturnType<typeof retakeSimulation>): any {
  const course = action.payload;

  const url = buildUrl(apiUrl, {
    path: `api/1.0/simulations/${course}/retake`,
  });

  const retakeSimulationAPI = () => {
    return axios({
      method: "POST",
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(retakeSimulationAPI);
    yield put(retakingSimulationSucceeded({ course: course, ...response }));
  } catch (error) {
    yield put(retakingSimulationFailed({ id: course, error }));
  }
};

export const invalidateRetakeSimulation = createAction<string>(INVALIDATE_RETAKE_SIMULATION);

//Complete Simulation
export const completeSimulation = createAction<CompleteSimulationRequest>(COMPLETE_SIMULATION);
const completingSimulationSucceeded = createAction<CompleteSimulationResponse>(COMPLETING_SIMULATION_SUCCEEDED);
const completingSimulationFailed = createAction<CompleteSimulationErrorResponse>(COMPLETING_SIMULATION_FAILED);

const completeSimulationSaga = function* (action: ReturnType<typeof completeSimulation>): any {
  const { id, session } = action.payload as CompleteSimulationRequest;

  console.log(action.payload);

  const url = buildUrl(apiUrl, {
    path: `api/1.0/simulations/${id}/complete`,
    queryParams: {
      session: session
    },
  });

  const completeCourseAPI = () => {
    return axios({
      method: "POST",
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(completeCourseAPI);
    yield put(completingSimulationSucceeded(response));
  } catch (error) {
    yield put(completingSimulationFailed({ id: id, error }));
  }
};

export const invalidateCompleteSimulation = createAction<string>(INVALIDATE_COMPLETE_SIMULATION);

//fetch simulation report
export const fetchSimulationReport = createAction<FetchSimulationAssessmentReportRequest>(FETCH_SIMULATION_REPORT_REQUEST);
const fetchingSimulationReportSucceeded = createAction<FetchSimulationAssessmentReportResponse>(FETCHING_SIMULATION_REPORT_SUCCEEDED);
const fetchingSimulationReportFailed = createAction<FetchSimulationAssessmentReportErrorResponse>(FETCHING_SIMULATION_REPORT_FAILED);

const fetchSimulationReportSaga = function* (action: ReturnType<typeof fetchSimulationReport>): any {
  const { id } = action.payload as FetchSimulationAssessmentReportRequest;
  const url = buildUrl(apiUrl, {
    path: `api/1.0/simulations/${id}/report`,
  });

  const fetchSimulationReportAPI = () => {
    return axios({
      method: "GET",
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchSimulationReportAPI);
    yield put(fetchingSimulationReportSucceeded({
      id: id,
      response: response
    }));
  } catch (error) {
    yield put(fetchingSimulationReportFailed({
      id: id,
      error: error
    }));
  }
}

export const invalidateSimulationReport = createAction<string>(INVALIDATE_SIMULATION_REPORT);

// fetch transcript for simulation
export const fetchTranscriptsForLearningSimulation = createAction<string>(FETCH_TRANSCRIPTS_FOR_LEARNING_SIMULATION_REQUEST);
const fetchingTranscriptsForLearningSimulationSucceeded = createAction<GetSimulationTranscriptsResponse>(FETCHING_TRANSCRIPTS_FOR_LEARNING_SIMULATION_SUCCEEDED);
const fetchingTranscriptsForLearningSimulationFailed = createAction<GetSimulationTranscriptsErrorResponse>(FETCHING_TRANSCRIPTS_FOR_LEARNING_SIMULATION_FAILED);

const fetchTranscriptsForLearningSimulationSaga = function* (action: ReturnType<typeof fetchTranscriptsForLearningSimulation>): any {
  const id = action.payload;

  const fetchTranscriptionAPI = () => {
    return axios({
      method: "GET",
      url: `${apiUrl}/api/1.0/simulations/${id}/transcripts`,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchTranscriptionAPI);
    yield put(
      fetchingTranscriptsForLearningSimulationSucceeded({
        id: id,
        response: response,
      }),
    );
  } catch (error) {
    yield put(fetchingTranscriptsForLearningSimulationFailed({ id: id, error: error }));
  }
};

// fetch lesson for learning record
export const fetchLessonForLearningRecord = createAction<FetchLessonForLearningRecordRequest>(FETCH_LESSON_FOR_LEARNING_RECORD_REQUEST);
const fetchingLessonForLearningRecordSucceeded = createAction<FetchLessonForLearningRecordResponse>(FETCHING_LESSON_FOR_LEARNING_RECORD_SUCCEEDED);
const fetchingLessonForLearningRecordFailed = createAction<FetchLessonForLearningRecordErrorResponse>(FETCHING_LESSON_FOR_LEARNING_RECORD_FAILED);

const fetchLessonForLearningRecordSaga = function* (action: ReturnType<typeof fetchLessonForLearningRecord>): any {
  const { learningRecord, lesson } = action.payload as FetchLessonForLearningRecordRequest;

  const url = buildUrl(apiUrl, {
    path: `/api/1.0/learning_record/${learningRecord}/lessons/${lesson}`
  });

  const fetchLessonForLearningRecordApi = () => {
    return axios({
      method: 'GET',
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchLessonForLearningRecordApi);
    yield put(fetchingLessonForLearningRecordSucceeded({
      learningRecord: learningRecord,
      lesson: lesson,
      asset: response
    }));
  } catch (error) {
    yield put(fetchingLessonForLearningRecordFailed({
      learningRecord: learningRecord,
      lesson: lesson,
      error: error
    }));
  }
}

// fetch lesson preview for learning record
export const fetchLessonPreviewForLearningRecord = createAction<FetchLessonPreviewForLearningRecordRequest>(FETCH_LESSON_PREVIEW_FOR_LEARNING_RECORD_REQUEST);
const fetchingLessonPreviewForLearningRecordSucceeded = createAction<FetchLessonPreviewForLearningRecordResponse>(FETCHING_LESSON_PREVIEW_FOR_LEARNING_RECORD_SUCCEEDED);
const fetchingLessonPreviewForLearningRecordFailed = createAction<FetchLessonPreviewForLearningRecordErrorResponse>(FETCHING_LESSON_PREVIEW_FOR_LEARNING_RECORD_FAILED);

const fetchLessonPreviewForLearningRecordSaga = function* (action: ReturnType<typeof fetchLessonPreviewForLearningRecord>): any {
  const { learningRecord, lesson, includeText } = action.payload as FetchLessonPreviewForLearningRecordRequest;

  const url = buildUrl(apiUrl, {
    path: `/api/1.0/learning_record/${learningRecord}/lessons/${lesson}/preview`,
    queryParams: {
      includeText: "" + includeText
    }
  });

  const fetchLessonPreviewForLearningRecordApi = () => {
    return axios({
      method: 'GET',
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchLessonPreviewForLearningRecordApi);
    yield put(fetchingLessonPreviewForLearningRecordSucceeded({
      learningRecord: learningRecord,
      lesson: lesson,
      preview: response
    }));
  } catch (error) {
    yield put(fetchingLessonPreviewForLearningRecordFailed({
      learningRecord: learningRecord,
      lesson: lesson,
      error: error
    }));
  }
}

//Podcast
export const fetchLearningRecordPodcast = createAction<string>(FETCH_LEARNING_RECORD_PODCAST_REQUEST);
const fetchingLearningRecordPodcastSucceeded = createAction<FetchLearningRecordPodcastResponse>(FETCHING_LEARNING_RECORD_PODCAST_SUCCEEDED);
const fetchingLearningRecordPodcastFailed = createAction<FetchLearningRecordPodcastErrorResponse>(FETCHING_LEARNING_RECORD_PODCAST_FAILED);

const fetchLearningRecordPodcastSaga = function* (action: ReturnType<typeof fetchLearningRecordPodcast>): any {
  const id = action.payload;

  const url = buildUrl(apiUrl, {
    path: `api/1.0/podcasts/${id}`,
  });

  const fetchLearningRecordPPodcastApi = () => {
    return axios({
      method: "GET",
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchLearningRecordPPodcastApi);
    yield put(
      fetchingLearningRecordPodcastSucceeded({
        response: response,
      }),
    );
  } catch (error) {
    console.log(error);
    yield put(fetchingLearningRecordPodcastFailed({ id: id, error: error }));
  }
};

//Start Podcast
export const startPodcast = createAction<string>(START_PODCAST_REQUEST);
const startingPodcastSucceeded = createAction<StartPodcastResponse>(STARTING_PODCAST_SUCCEEDED);
const startingPodcastFailed = createAction<StartPodcastErrorResponse>(STARTING_PODCAST_FAILED);

const startPodcastSaga = function* (action: ReturnType<typeof startPodcast>): any {
  const podcast = action.payload;

  const url = buildUrl(apiUrl, {
    path: `api/1.0/podcasts/${podcast}/start`,
  });

  const startPodcastAPI = () => {
    return axios({
      method: "POST",
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(startPodcastAPI);
    yield put(startingPodcastSucceeded(response));
  } catch (error) {
    yield put(startingPodcastFailed({ id: podcast, error }));
  }
};

export const invalidateStartPodcast = createAction<string>(INVALIDATE_START_PODCAST);

// Update podcast session
export const updatePodcastSession = createAction<UpdatePodcastSessionRequest>(UPDATE_PODCAST_SESSION_REQUEST);
const updatingPodcastSessionSucceeded = createAction<UpdatePodcastSessionResponse>(UPDATING_PODCAST_SESSION_SUCCEEDED);
const updatingPodcastSessionFailed = createAction<UpdatePodcastSessionErrorResponse>(UPDATING_PODCAST_SESSION_FAILED);

const updatePodcastSessionSaga = function* (action: ReturnType<typeof updatePodcastSession>): any {
  const event = action.payload as UpdatePodcastSessionRequest;

  const data = event.request;

  const recordSessionAPI = () => {
    return axios({
      method: "PUT",
      url: `${apiUrl}/api/1.0/podcasts/sessions/${event.id}`,
      data: data,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(recordSessionAPI);
    yield put(updatingPodcastSessionSucceeded({
      podcast: event.podcast,
      learningRecord: event.learningRecord,
      response: response,
    }));
  } catch (error) {
    yield put(updatingPodcastSessionFailed({
      podcast: event.podcast,
      learningRecord: event.learningRecord,
      id: event.id,
      error: error
    }));
  }
};

export const fetchTranscriptsForLearningPodcast = createAction<string>(FETCH_TRANSCRIPTS_FOR_LEARNING_PODCAST_REQUEST);
const fetchingTranscriptsForLearningPodcastSucceeded = createAction<GetPodcastTranscriptsResponse>(FETCHING_TRANSCRIPTS_FOR_LEARNING_PODCAST_SUCCEEDED);
const fetchingTranscriptsForLearningPodcastFailed = createAction<GetPodcastTranscriptsErrorResponse>(FETCHING_TRANSCRIPTS_FOR_LEARNING_PODCAST_FAILED);

const fetchTranscriptsForLearningPodcastSaga = function* (action: ReturnType<typeof fetchTranscriptsForLearningPodcast>): any {
  const id = action.payload;

  const fetchTranscriptionAPI = () => {
    return axios({
      method: "GET",
      url: `${apiUrl}/api/1.0/podcasts/${id}/transcripts`,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchTranscriptionAPI);
    yield put(
      fetchingTranscriptsForLearningPodcastSucceeded({
        id: id,
        response: response,
      }),
    );
  } catch (error) {
    yield put(fetchingTranscriptsForLearningPodcastFailed({ id: id, error: error }));
  }
};

export const triggerSimulationCallMessage = createAction<string>(TRIGGER_SIMULATION_CALL_MESSAGE);
const triggerSimulationCallMessageSucceeded = createAction(TRIGGER_SIMULATION_CALL_MESSAGE_SUCCEEDED);
const triggerSimulationCallMessageFailed = createAction(TRIGGER_SIMULATION_CALL_MESSAGE_FAILED);

const triggerSimulationCallMessageSaga = function* (action: ReturnType<typeof triggerSimulationCallMessage>): any {
  const session = action.payload;

  const url = buildUrl(apiUrl, {
    path: `api/1.0/simulations/vapi/call/message`,
    queryParams: { session }
  });

  const triggerSimulationCallMessageApi = () => {
    return axios({
      method: "POST",
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(triggerSimulationCallMessageApi);
    yield put(triggerSimulationCallMessageSucceeded());
  } catch (error) {
    yield put(triggerSimulationCallMessageFailed());
  }
};

export default function* learnersSaga() {
  yield takeEvery(ADD_LEARNER_TO_COURSE_REQUEST, addLearnerToCourseSaga);
  yield takeLatest(FETCH_COURSE_LEARNERS_REQUEST, fetchCourseLearnersSaga);
  yield takeEvery(FETCH_LEARNERS_REQUEST, fetchLearnersSaga);
  yield takeEvery(FETCHING_MY_COURSES_REQUEST, fetchMyCoursesSaga);
  yield takeEvery(START_COURSE_REQUEST, startCourseSaga);
  yield takeEvery(ENROLL_COURSE_REQUEST, enrollCourseSaga);
  yield takeEvery(UPDATE_COURSE_SESSION_REQUEST, updateCourseSessionSaga);
  yield takeEvery(COMPLETE_COURSE_REQUEST, completeCourseSaga);

  yield takeEvery(FETCH_LEARNING_RECORD_COURSE_REQUEST, fetchLearningRecordCourseSaga);

  yield takeEvery(CREATE_LESSON_ANALYTICS_EVENT, createLessonAnalyticsEventSaga);
  yield takeEvery(RECORD_LESSON_ANALYTICS_EVENT, recordLessonAnalyticsEventSaga);
  yield takeEvery(CREATE_COURSE_CONTENT_SESSION_REQUEST, createCourseContentSessionSaga);
  yield takeEvery(UPDATE_COURSE_CONTENT_SESSION_REQUEST, updateCourseContentSessionSaga);
  yield takeEvery(FETCH_COURSE_CONTENT_SESSION_REQUEST, fetchCourseContentSessionSaga);
  yield takeEvery(RESTART_SIMULATION_LESSON_SESSION_REQUEST, restartSimulationLessonSessionSaga);
  yield takeEvery(FETCH_ASSESSMENT_REPORT_REQUEST, fetchAssessmentReportSaga);
  yield takeEvery(COMPLETE_COURSE_CONTENT_SESSION_REQUEST, completeCourseContentSessionSaga);
  yield takeEvery(RECORD_QUESTION_SESSION_REQUEST, recordQuestionSessionSaga);

  yield takeEvery(FETCH_LESSON_FOR_LEARNING_RECORD_REQUEST, fetchLessonForLearningRecordSaga);
  yield takeEvery(FETCH_LESSON_PREVIEW_FOR_LEARNING_RECORD_REQUEST, fetchLessonPreviewForLearningRecordSaga);

  yield takeEvery(FETCH_LEARNING_RECORD_SIMULATION_REQUEST, fetchLearningRecordSimulationSaga);
  yield takeEvery(START_SIMULATION, startSimulationSaga);
  yield takeEvery(COMPLETE_SIMULATION, completeSimulationSaga);
  yield takeEvery(RESTART_SIMULATION, restartSimulationSaga);
  yield takeEvery(FETCH_SIMULATION_REPORT_REQUEST, fetchSimulationReportSaga);
  yield takeEvery(FETCH_TRANSCRIPTS_FOR_LEARNING_SIMULATION_REQUEST, fetchTranscriptsForLearningSimulationSaga);
  yield takeEvery(ENROLL_SIMULATION_REQUEST, enrollSimulationSaga);
  yield takeEvery(ENROLL_PODCAST_REQUEST, enrollPodcastSaga);
  yield takeEvery(RETAKE_COURSE_REQUEST, retakeCourseSaga);
  yield takeEvery(RETAKE_SIMULATION_REQUEST, retakeSimulationSaga);

  yield takeEvery(FETCH_LEARNING_RECORD_PODCAST_REQUEST, fetchLearningRecordPodcastSaga);
  yield takeEvery(START_PODCAST_REQUEST, startPodcastSaga);
  yield takeEvery(UPDATE_PODCAST_SESSION_REQUEST, updatePodcastSessionSaga);
  yield takeEvery(FETCH_TRANSCRIPTS_FOR_LEARNING_PODCAST_REQUEST, fetchTranscriptsForLearningPodcastSaga);
  yield takeEvery(JOIN_DAILY_ROOM_REQUEST, joinDailyRoomSaga);
  yield takeEvery(TRIGGER_SIMULATION_CALL_MESSAGE, triggerSimulationCallMessageSaga);
}
